import Vue from 'vue';

Vue.component('model-microsite-model-specs-component', {
    props: {
        darkMode: {
            type: Boolean,
            required: false,
            default: false,
        },
        modelSpecs: {
            type: Array,
            required: true,
        },
        allSpecs: {
            type: Object,
            required: true,
        },
        modelName: {
            type: String,
            default: 'MG',
        },
    },

    data() {
        return {
            specificationCategories: [],
            selectedCategory: this.modelSpecs[0].category,
            selectedSpecification: this.modelSpecs[0],
            areSpecsVisible: false,

            selectedSpecs: null,
            selectedConfigurationTitle: null,
            selectedConfiguration: null,
            specsSelectedModelName: null,
            selectedSpecsModelType: null,
            selectedSpecsModelSublineAsset: null,
            selectedSpecsModelSubline: null,
            selectedSpecsDisclaimer: null,
            specsTriggerButton: null,
        };
    },

    mounted() {
        this.getSpecificationCategories();

        this._escHandler = (event) => {
            if (event.key !== 'Escape') return;
            event.preventDefault();
            this.closeSpecs(true);
        };
    },

    beforeDestroy() {
        document.removeEventListener('keydown', this._escHandler);
    },

    methods: {
        parseImage(image) {
            return JSON.parse(image);
        },

        getSpecificationCategories() {
            this.specificationCategories = this.modelSpecs.map(
                (specification) => specification.category,
            );
        },

        selectModelSpecification(passedCategory) {
            this.selectedCategory = passedCategory;
            this.selectedSpecification = this.modelSpecs.find(
                (specification) => specification.category === passedCategory,
            );
        },

        handleSelectedButtonClass(specificationCategory) {
            return this.selectedCategory === specificationCategory
                ? `model-microsite-model-specs__specs__button--${
                      this.darkMode ? 'dark' : 'light'
                  }--selected`
                : '';
        },

        openSpecs(event) {
            this.areSpecsVisible = true;
            this.selectedSpecs = this.allSpecs;
            this.selectedConfigurationTitle = this.allSpecs.values[0].title;
            this.selectedConfiguration = this.getSelectedConfiguration(
                this.allSpecs.values[0].title,
            );
            this.specsSelectedModelName = this.modelName;
            this.selectedSpecsModelType = '';
            this.selectedSpecsModelSubline = '';
            this.selectedSpecsModelSublineAsset = null;
            this.specsTriggerButton = event?.currentTarget;

            document.body.style.overflow = 'hidden';
            document.addEventListener('keydown', this._escHandler);

            this.$nextTick(() => {
                const closeButton = this.$el.querySelector(
                    '.new-model-specs__close-button',
                );
                if (closeButton) {
                    closeButton.focus();
                }
            });
        },

        getSelectedConfiguration(configuration) {
            const selectedConfiguration = this.allSpecs.values.find(
                (configValue) => configValue.title === configuration,
            );
            if (!selectedConfiguration) return null;
            this.selectedSpecsDisclaimer = selectedConfiguration.disclaimer;

            const { editions, values } = selectedConfiguration;

            const filteredEditions = editions.filter(
                (edition) => !edition.isDisabled,
            );

            if ('colorTitle' in values[0]) {
                const tableTitle = [
                    { title: values[0].title },
                    ...filteredEditions.map((edition) => ({
                        title: edition.name || '',
                        subtitle: edition.subtitle,
                    })),
                ];
                const parsedColorValues = values.map((value) => [
                    {
                        colorTitle: value?.colorTitle,
                        colorImage: value.image?.url,
                    },
                    ...this.parseValues(value.values[0]),
                ]);
                return [{ tableTitle, tableData: parsedColorValues }];
            }
            const tableData = values.map((value) => ({
                tableTitle: [
                    { title: value.title },
                    ...filteredEditions.map((edition) => ({
                        title: edition.name,
                        subtitle: edition.subtitle,
                    })),
                ],
                tableData: value.values,
            }));

            return tableData;
        },

        parseValues(values) {
            if (Array.isArray(values)) return values;
            if (typeof values === 'object') {
                return Object.values(values);
            }
            return [];
        },

        closeSpecs(returnFocus) {
            this.areSpecsVisible = false;
            document.body.style.overflow = 'auto';
            document.removeEventListener('keydown', this._escHandler);

            if (returnFocus !== true) return;
            this.$nextTick(() => {
                const triggerButton = this.$el.querySelector(
                    '.model-microsite-model-specs__button-container .button-v2',
                );

                if (triggerButton) {
                    triggerButton.focus();
                }
            });
        },

        selectConfiguration(configuration) {
            this.selectedConfigurationTitle = configuration;
            this.selectedConfiguration =
                this.getSelectedConfiguration(configuration);
        },

        isFirstTitle(index) {
            return index === 0
                ? 'new-model-specs__table__header__title--first'
                : '';
        },

        isFirstDataItem(index) {
            return index === 0
                ? 'new-compare-block__table-data__item--first'
                : '';
        },

        isSelectedConfiguration(configuration) {
            const activeClass = this.darkMode
                ? 'new-model-specs__sidebar__selector--light-active'
                : 'new-model-specs__sidebar__selector--active';
            return this.selectedConfigurationTitle === configuration
                ? activeClass
                : '';
        },

        checkItemsLength(selectedConfiguration) {
            return selectedConfiguration[0].tableTitle.length <= 3
                ? ''
                : 'new-model-specs__table-container--horizontal-scroll';
        },
    },
});
